/* PDP — Decoupling de thumbs vs main slider
   El theme original inicializa Flickity en los thumbnails con
   "asNavFor" apuntando al main slider, lo que hace que cuando el
   usuario hace swipe en la imagen principal, los thumbs también se
   mueven automáticamente.

   Lo que queremos: thumbs ESTÁTICOS — sólo se mueven cuando el
   usuario los arrastra/swipe directamente con el dedo.

   Solución: destruir la instancia de Flickity en los thumbs después
   del init del theme. La CSS del theme tiene fallback con
   `.product-single__thumbnails:not(.flickity-enabled)` que aplica
   `display: flex; overflow-x: auto;` — exactamente el comportamiento
   estático + scroll horizontal con el dedo. */
(function () {
  function destroyThumbsFlickity() {
    var thumbs = document.querySelectorAll(
      '[data-product-single-media-thumbs], #ProductThumbs, .product-single__thumbnails'
    );
    if (!thumbs.length) return false;
    var destroyed = false;
    thumbs.forEach(function (el) {
      try {
        var FlickityCls = (window.theme && window.theme.Flickity) || window.Flickity;
        if (FlickityCls && typeof FlickityCls.data === 'function') {
          var instance = FlickityCls.data(el);
          if (instance) {
            instance.destroy();
            destroyed = true;
          }
        }
      } catch (e) { /* ignore */ }
    });
    return destroyed;
  }

  // Click en thumb → cambiar slide principal manualmente.
  // Necesario porque al destruir Flickity, perdemos el handler nativo.
  function attachThumbClickHandlers() {
    var slider = document.querySelector('[data-product-single-media-slider]');
    if (!slider) return false;
    var thumbs = document.querySelectorAll(
      '.product-single__thumbnail-link, .product-single__thumbnail [href]'
    );
    if (!thumbs.length) return false;

    thumbs.forEach(function (link) {
      if (link.dataset.sofThumbBound === '1') return;
      link.dataset.sofThumbBound = '1';
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var thumbWrap = link.closest('.product-single__thumbnail');
        if (!thumbWrap) return;
        var mediaId = thumbWrap.dataset.id || thumbWrap.dataset.thumbnailId;
        if (!mediaId) return;
        // Hacer click en el slider principal para que el theme cambie la slide
        var FlickityCls = (window.theme && window.theme.Flickity) || window.Flickity;
        if (FlickityCls && typeof FlickityCls.data === 'function') {
          var inst = FlickityCls.data(slider);
          if (inst) {
            // Buscar el índice de la slide que tiene este media-id
            var slides = slider.querySelectorAll('.product-gallery__media-slide');
            for (var i = 0; i < slides.length; i++) {
              if (slides[i].dataset.id === mediaId || slides[i].dataset.mediaId === mediaId) {
                inst.select(i, false, false);
                return;
              }
            }
          }
        }
        // Fallback: alternar clases manually
        var slidesAll = document.querySelectorAll('.product-gallery__media-slide');
        slidesAll.forEach(function (s) {
          s.classList.add('media--hidden');
          s.classList.remove('is-selected');
        });
        var target = document.querySelector(
          '.product-gallery__media-slide[data-id="' + mediaId + '"], .product-gallery__media-slide[data-media-id="' + mediaId + '"]'
        );
        if (target) {
          target.classList.remove('media--hidden');
          target.classList.add('is-selected');
        }
      });
    });
    return true;
  }

  // Marcar el thumb activo cuando el main slider cambia,
  // para feedback visual (el thumb actual se ve "encendido")
  function syncActiveThumb() {
    var slider = document.querySelector('[data-product-single-media-slider]');
    if (!slider) return;
    var slides = slider.querySelectorAll('.product-gallery__media-slide');
    function setActive() {
      var activeId = null;
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].classList.contains('is-selected')) {
          activeId = slides[i].dataset.id || slides[i].dataset.mediaId;
          break;
        }
      }
      if (!activeId) return;
      document.querySelectorAll('.product-single__thumbnail').forEach(function (t) {
        var tid = t.dataset.id || t.dataset.thumbnailId;
        if (tid === activeId) {
          t.classList.add('is-active');
        } else {
          t.classList.remove('is-active');
        }
      });
    }
    setActive();
    if (window.MutationObserver) {
      var obs = new MutationObserver(setActive);
      slides.forEach(function (s) {
        obs.observe(s, { attributes: true, attributeFilter: ['class'] });
      });
    }
  }

  function run() {
    var didDestroy = destroyThumbsFlickity();
    attachThumbClickHandlers();
    syncActiveThumb();
    return didDestroy;
  }

  // Reintentos: el theme puede inicializar Flickity tarde
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  setTimeout(run, 600);
  setTimeout(run, 1500);
  setTimeout(run, 3000);
})();
